<template>
  <el-table
    ref="elTable"
    border
    stripe
    :data="tableData"
    @select="handleSelect"
    @selection-change="handleCheckedChange"
    @current-change="handleRadioChange"
    :highlight-current-row="radio"
    :row-class-name="tableRowClassName"
    :max-height="maxHeight"
  >
    <template v-for="(column, cIndex) in columns">
      <el-table-column
        v-if="column.sequence"
        align="center"
        :key="cIndex"
        :type="column.sequence"
        :label="column.label"
        :width="column.width || 'auto'"
      ></el-table-column>
      <el-table-column
        v-else-if="column.image"
        align="center"
        :key="cIndex"
        :label="column.label"
        width="100px"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row[column.prop]"
            width="60"
            height="60"
            :onerror="defaultImg"
            style="margin: 10px auto;display: block;"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-else-if="column.color"
        align="center"
        :key="cIndex"
        :label="column.label"
        :width="column.width || 'auto'"
      >
        <template slot-scope="scope">
          <span :style="`color: ${column.rgb}`">{{column.formatter(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-else
        align="center"
        :key="cIndex"
        :prop="column.prop"
        :label="column.label"
        :width="column.width || 'auto'"
        :formatter="column.formatter"
      ></el-table-column>
    </template>
    <slot></slot>
  </el-table>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: (() => [])
    },
    radio: { // 高亮
      type: Boolean,
      default: false
    },
    tableRowClassName: { // 行的 className 的回调方法，也可以使用字符串为所有行设置一个固定的 className
      type: [String, Function],
      default: ""
    },
    maxHeight: { // Table 的最大高度。合法的值为数字或者单位为 px 的高度。
      type: String,
      default: '100%'
    },
    columns: { // 列集合
      type: Array,
      default: function () {
        return [];
      }
    },
  },
  data () {
    return {
      defaultImg: 'this.src="' + require("../../assets/timg.jpg") + '"'
    };
  },
  methods: {
    handleSelect (data) {
      this.$emit("checked", data);
    },
    handleCheckedChange (data) {
      this.$emit("checkedChange", data);
    },
    handleRadioChange (data) {
      this.$emit("radioChange", data);
    },
    clearSelection () { // 用于多选表格，清空用户的选择
      this.$refs.elTable.clearSelection();
    },
    toggleRowSelection (row, selected) { // 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
      this.$refs.elTable.toggleRowSelection(row, selected);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myTable/index.vue